import LogService from '../services/LogService';

/**
 * @description Logs a message for a given user, if their account is set to debug mode.
 * @param {*} user
 * @param {*} message
 * @param {*} data
 */
export const debug = async (user, message, data?) => {
    if ((process.env.DEBUG || '') == 'true') {
        console.log(`DEBUG: ${message}`, data ? data : '(no data)', 'user:', user);
    }
    if (!user) console.log(`Warning: no user given for debug: ${message}`, data);
    // log the debug if account is debug and not on dev environment.
    if (user && user.debug && (!IS_DEV || process.env.DEBUG=='true')) {
        await LogService.debug(user, message, data)
    }
}

// todo: move to debug utils?
export const IS_DEV = () => {
    return process.env.NODE_ENV != 'production';
}